export default __webpack_public_path__ + "static/Fig 6 - Indicative Infra A1-eeb2e30afb91bbf2187cb5d1fdad2fcf.pdf";